import Info from "inferno-feather/dist/icons/info";
import User from "inferno-feather/dist/icons/user";
import {BgColor, Color, Entity} from "../../utils/types";

export function AgentAvatar(props: { name: string, color?: Color, bgColor?: BgColor, width: string, height: string, entity?: Entity }) {
	let initials: any = props.name.split(" ");
	if (initials.length > 1) {
		initials = initials[0][0] + initials[1][0];
	} else {
		initials = initials[0][0];
	}
	const css = "d-inline-flex rounded-circle " + (props.color ? props.color : Color.White) + " " + (props.bgColor ? props.bgColor : BgColor.Info);
	const style: any = {
		width: props.width,
		height: props.height,
		"min-width": props.width,
		"min-height": props.height,
		"align-items": "center"
	};
	switch (props.entity) {
		case Entity.system:
			return (
				<div className={css} style={style}>
					<Info className="m-auto"/>
				</div>
			);
		case Entity.unknown:
			return (
				<div className={css} style={style}>
					<User className="m-auto"/>
				</div>
			);
		default:
			return (
				<div className={css} style={style}>
					<p className="m-auto">{initials}</p>
				</div>
			);
	}
}
